import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const TabContent = styled('div')``

export const Label = styled('div')<{ theme?: TTheme }>`
    border-radius: 100px;
    width: 100px;
    background: ${({ theme }) => theme.colors.primary[100]};
    color: ${({ theme }) => theme.colors.primary[600]};
    display: flex;
    padding: 5px 15px;
    justify-content: center;
    align-items: center;
    gap: 10px;
`
